// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // api_url: 'http://192.168.1.6/AbangRestApi/public',
  // api_url_agen: 'http://192.168.1.6/AbangRestApi/public/agen-cabang',
  // api_url_mitra: 'https://192.168.1.6/AbangRestApi/public/mitra/v3',
  // api_url_notif_service: 'https://gateway.abangexpress.co.id/api',

  // api_url: 'https://testing-api.abangexpress.co.id',
  // api_url_agen: 'https://testing-api.abangexpress.co.id/agen-cabang',
  // api_url_mitra: 'https://testing-api.abangexpress.co.id/mitra/v3',

  // api_url: 'http://abangrestapi.ae',
  // api_url_agen: 'http://abangrestapi.ae/agen-cabang',
  // api_url_mitra: 'http://abangrestapi.ae/mitra/v3',
  // api_url_notif_service: 'https://ax-gateway.ap.ngrok.io/api',

  // api_url: 'https://api.abangexpress.co.id',
  // api_url_agen: 'https://api.abangexpress.co.id/agen-cabang',
  // api_url_mitra: 'https://api.abangexpress.co.id/mitra/v3',
  // api_url_notif_service: 'https://gateway.abangexpress.co.id/api',

  api_url: 'https://api-sandbox.abangexpress.co.id',
  api_url_agen: 'https://api-sandbox.abangexpress.co.id/agen-cabang',
  api_url_mitra: 'https://api-sandbox.abangexpress.co.id/mitra/v3',
  api_url_notif_service: 'https://gateway.abangexpress.co.id/api',
  api_url_postal_service: 'https://postal-service.abangexpress.co.id/postal',

  api_url_support: 'https://support.abangexpress.co.id/api',

  api_url_pakdome: 'https://api-dev.pakdome.com/abangexpress',
  api_key_pakdome: '3af4a339d65ad2fa2cf902ece202bfc5',
  pakdome_url: 'https://dev-b2c.pakdome.com',

  version: '1.12.0',
  MOCK_API: false,
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
